export default __webpack_public_path__ + "images/legal-stuff-fashion.svg";